import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Vg2Shell } from "./Vg2Shell";
import { getJourney } from "@/lib/vg2Journey";

/**
 * §valuta-single · Le vecchie route del percorso a 7 schermate (CAPISCI
 * flow, esito CAPISCI, transizione "Ora misuriamo", VALUTA multi-step)
 * ora riprendono nella scheda VALUTA unica conservando i dati. Se il
 * journey ha già una valutazione, apre direttamente il risultato.
 */
export default function LegacyJourneyRedirect() {
  const { journeyId } = useParams();
  const navigate = useNavigate();

  React.useEffect(() => {
    (async () => {
      if (!journeyId) { navigate("/vg2", { replace: true }); return; }
      try {
        const j = await getJourney(journeyId);
        const anId = (j.answers || {}).V_analysis_id;
        if (anId) {
          navigate(`/vg2/valuta/${journeyId}/risultato/${anId}`, { replace: true });
        } else {
          navigate(`/vg2/${journeyId}`, { replace: true });
        }
      } catch {
        navigate(`/vg2/${journeyId}`, { replace: true });
      }
    })();
  }, [journeyId, navigate]);

  return (
    <Vg2Shell>
      <div className="pt-24 text-vg2-muted" data-testid="legacy-redirect">
        Un momento…
      </div>
    </Vg2Shell>
  );
}
